<template lang="pug">
div
  template(v-if="racingList.includes(sportsType)")
    template(v-if="racingList1.includes(sportsType)")
      template(v-for="(g1, g2) in group")
        efItem3(:source="g1" :index="parseInt(g2)" :key="g2")
    template(v-else)
      template(v-for="(g1, g2) in group")
        efItem4(:source="g1" :index="parseInt(g2)" :key="g2")
  template(v-else)
    template(v-for="(g1, g2) in group")
      efItem2(:source="g1" :index="parseInt(g2)" :key="g2")
</template>

<script>
import config from '@/config';

export default {
  components: {
    efItem2: () => import("@/components/mobile/efight/efItem2.vue"),
    efItem3: () => import("@/components/mobile/efight/efItem3.vue"),
    efItem4: () => import("@/components/mobile/efight/efItem4.vue")
  },
  props: {
    source: {
      type: Array
    },
    sportsType: {
      type: Number
    }
  },
  data() {
    return {};
  },
  computed: {
    racingList() {
      return config.racingList;
    },
    racingList1() {
      return config.racingList1;
    },
    group() {
      var g = {};
      for (var i = 0; i < this.source.length; i++) {
        if (!g.hasOwnProperty(this.source[i].matchBody[9])) {
          g[this.source[i].matchBody[9]] = {
            items: [],
            teams: []
          };
        }

        // g[this.source[i].matchBody[9]].marketId = this.source[i].marketId;
        // g[this.source[i].matchBody[9]].matchTime = this.source[i].matchTime;
        g[this.source[i].matchBody[9]].items.push(this.source[i]);
        g[this.source[i].matchBody[9]].teams.push(this.source[i].homeTeam);
      }
      return g;
    }
  },
  mounted() {},
  methods: {}
}

</script>